module.exports = __webpack_public_path__ + "static/assets/d6e5272e21f7f0cf1d906d63686ec14c.svg";